export default __webpack_public_path__ + "static/media/3-min.6bb3a005.jpg";